<template>
  <div>
    <alert-error :error="error" />

    <v-toolbar>
      <v-toolbar-title
        >{{ $t('ITEM.VIEW') }} {{ $t('NOTIFICATIONS.ITEM') }}</v-toolbar-title
      >
      <v-spacer />
      <v-btn depressed color="error" @click="remove">
        {{ $t('BUTTON.DELETE') }}
      </v-btn>
      <confirm-dialog ref="confirm"></confirm-dialog>
      <v-btn class="ml-2" dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
      <v-btn
        class="ml-2"
        color="primary"
        :disabled="!canBeUpdated"
        @click="
          $router.push({
            name: 'notifications.edit',
            params: { id: id }
          })
        "
      >
        {{ $t('BUTTON.EDIT') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-form ref="form">
        <item-build v-if="localItem" v-model="localItem" :readonly="true" />
      </v-form>
    </v-sheet>
  </div>
</template>

<script>
import { Notification } from '@/modules/notifications/Notification';
import { NotificationsService } from '@/services/notifications.service';

export default {
  name: 'NotificationShowPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ItemBuild: () =>
      import('@/modules/notifications/components/NotificationBuild.vue'),
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    localItem: null,
    error: null,
    languages: null,
    canBeUpdated: null
  }),

  created() {
    this.helperItem = new Notification();

    this.$store
      .dispatch('localization/retrieveLanguages')
      .then(response => {
        this.languages = response.data;

        this.$store
          .dispatch('notification/retrieve', this.id)
          .then(({ data }) => {
            this.localItem = this.helperItem.initFrontendNotification(
              data,
              this.languages
            );

            this.canBeUpdated = this.helperItem.canBeUpdated(
              data.dispatch_time
            );
          });
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    remove() {
      this.$refs.confirm
        .open(this.$t('NOTIFICATIONS.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            NotificationsService.remove(this.localItem.id)
              .then(({ data }) => {
                this.$emit('updated', data.data);
                this.$store.commit('snackbar/setSnack', {
                  status: 'success',
                  text: this.$t('MESSAGE.SUCCESS')
                });

                this.$router.push({ name: 'notifications' });
              })
              .catch(this.handleErrors);
          }
        });
    }
  }
};
</script>
